import React from "react"; // eslint-disable-line no-unused-vars
import ReactDOM from "react-dom";
import App from "./components/app";
import { Provider } from "./store/provider";

if (process.env.NODE_ENV === "development") {
  console.log("TB-CHARITY: Loading");
}

let render = function (app, theme) {
  ReactDOM.render(
    <React.Fragment>
      <Provider>
        <App theme={theme} />
      </Provider>
    </React.Fragment>,
    app
  );
};

let loadApp = function () {
  if (process.env.NODE_ENV === "development") {
    console.log("TB-CHARITY: Initializing React component");
  }
  let app = document.getElementById("tbcharity");
  if (app) {
    fetch(process.env.THEME_URL)
      .then((response) => response.json())
      .then((theme) => {
        render(app, theme);
      })
      .catch((error) => {
        if (process.env.NODE_ENV === "development") {
          console.log("TB-CHARITY: ", error);
        }
        render(app, {});
      });
  } else {
    if (process.env.NODE_ENV === "development") {
      console.log("TB-CHARITY: No element to insert component into");
    }
  }
};
if (document.readyState === "loading") {
  if (process.env.NODE_ENV === "development") {
    console.log("TB-CHARITY: Waiting for document ready state");
  }
  document.addEventListener("DOMContentLoaded", loadApp);
} else {
  loadApp();
}
